import React from "react";
import PropTypes from "prop-types";
import { Item } from "semantic-ui-react";
import { Paginate } from "../../components";
import Link from "next/link";
import { header, subheader, description, extra } from "./element";
import millify from "millify";

var humanFormat = require("human-format");
const CustomItems = ({ id, itemData, prev, active, ...props }) => {
  let data = 0;
  if (itemData && itemData !== null) {
    data = itemData.length;
  }
  let page_size = 3;
  let indexdata = (active - 1) * page_size;

  return (
    <div>
      <Item.Group style={{ cursor: "pointer" }}>
        {data != 0 &&
          itemData
            .slice(indexdata)
            .slice(0, page_size)
            .map((item, index) => {
              let beddata = `${item.bedCount} Beds, `;
              let bathdata = `${item.bathCount} Baths`;
              let price = `$${humanFormat(item.price).replace(/\s/g, "")}`;
              let imageurl = "";
              {
                item.newimageurl
                  ? (imageurl = item.newimageurl)
                  : (imageurl =
                      process.env.NEXT_PUBLIC_CDN_ID +
                      "static/images/Neighborhood1.jpg");
              }
              return (
                <Item key={index}>
                  <Item.Image
                    onClick={() =>
                      window.open(`/DetailsListing/?id=${item.id}`, "_blank")
                    }
                    {...props}
                    src={imageurl}
                  />
                  <Item.Content verticalAlign="top">
                    <Link
                      {...props}
                      style={{ cursor: "pointer" }}
                      target="_blank"
                    >
                      {/* <a style={{ cursor: "pointer" }} target="_blank"> */}
                      <Item.Header content={item.address} style={header} />
                      {/* </a> */}
                    </Link>
                    {item.bedCount ? (
                      <Item.Description
                        content={beddata}
                        {...props}
                        style={description}
                      />
                    ) : null}
                    {item.bathCount ? (
                      <Item.Description
                        content={bathdata}
                        {...props}
                        style={description}
                      />
                    ) : null}
                    {item.price ? (
                      <Item.Extra content={price} style={extra} />
                    ) : null}
                  </Item.Content>
                </Item>
              );
            })}
      </Item.Group>
      {itemData && itemData !== null && itemData.length > 3 && (
        <Paginate
          length={data}
          prev={prev}
          active={active}
          id={id}
          {...props}
        />
      )}
    </div>
  );
};

CustomItems.propTypes = {
  itemData: PropTypes.array,
};
export default CustomItems;
